<template>
  <div id="loading-overlay">
    <div id="loading-container">
      <h1 id="app-name">
        {{ generalStore.appName }}
      </h1>
      <p id="loading-message">
        Loading
        <span ref="dot" class="dot">.</span>
        <span ref="dot" class="dot">.</span>
        <span ref="dot" class="dot">.</span>
        <!-- Interesting observation: The animation looks ugly with just three spans, but with this comment it looks decent. -->
        <!-- <span class="dot" ref="dot">.</span> -->
      </p>
      <p id="tagline">
        {{ generalStore.tagline }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGeneralStore } from "@/pinia/general-store"

const generalStore = useGeneralStore()
</script>

<style lang="css" scoped>
@keyframes inout {
  0% { opacity: 1; }
  50% { opacity: 0; }
  70% { opacity: 1; }
}

#loading-overlay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10000;
  background-color: var(--color-background);

  #loading-container {
    max-width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    h1#app-name { font-size: 1em; font-weight: bold; }
    p#tagline { font-size: 0.8em; }

    p#loading-message {
      font-size: 4em;
      font-weight: 200;
      white-space: nowrap;

      .dot {
        display: inline-block;
        margin: 0px 2px;
        opacity: 1;
        animation: 1s infinite linear inout;

        &:nth-child(0) { animation-delay: 0ms; }
        &:nth-child(1) { animation-delay: 250ms; }
        &:nth-child(2) { animation-delay: 500ms; }
        &:nth-child(3) { animation-delay: 750ms; }
      }
    }
  }
}
</style>
